import { motion, AnimatePresence } from 'motion/react'
import type { ReactNode } from 'react'

type AnimatedFormContentProps = {
  isReplying: boolean
  isLoading?: boolean
  replyingContent: ReactNode
  formContent: ReactNode
}

export const AnimatedFormContent = ({
  isReplying,
  isLoading = false,
  replyingContent,
  formContent,
}: AnimatedFormContentProps): JSX.Element => {
  return (
    <AnimatePresence mode="wait" initial={false}>
      {isReplying ? (
        <motion.div
          key="replying"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          style={{ width: '100%' }}
        >
          {replyingContent}
        </motion.div>
      ) : (
        <motion.div
          key="form"
          initial={{ opacity: 0 }}
          animate={{
            height: isLoading ? 0 : 'auto',
            opacity: isLoading ? 0 : 1,
          }}
          transition={{
            height: { duration: 0.2, ease: 'easeInOut' },
            opacity: { duration: 0.2 },
          }}
          exit={{ opacity: 0 }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-xs)',
            width: '100%',
          }}
        >
          {formContent}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
